module.exports = __webpack_public_path__ + "static/media/Milex-Gehrung-Pessary-Instructions-for-Use@2x.6d2bdfbf.jpg";